var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidden
    ? _c(
        "div",
        { staticClass: "async-export-button" },
        [
          _c(
            "el-button",
            {
              style: _vm.mergedButtonStyle,
              attrs: {
                type: _vm.buttonType,
                size: _vm.size,
                icon: _vm.icon,
                loading: _vm.loading,
                disabled: _vm.disabled || _vm.loading,
              },
              on: { click: _vm.handleExport },
            },
            [_vm._v("\n    " + _vm._s(_vm.displayText) + "\n  ")]
          ),
          _vm._v(" "),
          _vm.showProgressDialog
            ? _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisible,
                    title: "导出进度",
                    width: "500px",
                    "append-to-body": "",
                    "custom-class": "async-export-dialog",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVisible = $event
                    },
                  },
                },
                [
                  _c("div", { staticClass: "export-dialog-content" }, [
                    _c("i", { staticClass: "el-icon-download export-icon" }),
                    _vm._v(" "),
                    _c("h3", { staticClass: "export-title" }, [
                      _vm._v(_vm._s(_vm.statusText)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "progress-container" },
                      [
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.progress,
                            "stroke-width": 20,
                            status: _vm.progressStatus,
                            "text-inside": true,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "progress-info" }, [
                          _c("span", [_vm._v(_vm._s(_vm.statusText))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.progress) + "%")]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.loading
                      ? _c("div", { staticClass: "export-tip" }, [
                          _c("i", { staticClass: "el-icon-info" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("关闭弹窗不会中断导出任务")]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }